<template>
    <b-form @submit="onSubmit">
        <b-form-group label="Report ID">
            <b-form-input
                name="report_id"
                v-model="report.report_id"
                required
            ></b-form-input>
        </b-form-group>
        <b-form-group label="Report Date">
            <b-form-input
                name="report_date"
                v-model="report.report_date"
                type="date"
                required
            ></b-form-input>
        </b-form-group>
        <b-form-group label="Manufacturer">
            <b-form-select
                v-model="selectedManufacturer"
                :options="manufacturers"
                value-field="id"
                text-field="name"
                required
            ></b-form-select>
        </b-form-group>
        <b-form-group label="Comment">
            <b-form-textarea
                id="textarea"
                v-model="report.comment"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
        </b-form-group>
        <b-button :disabled="submitDisabled" type="submit" variant="primary"
            >Update report</b-button
        >
    </b-form>
</template>

<script>
import axios from "axios";

export default {
  name: "EditForm",
  props: {
    reportData: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      loading: true,
      report: this.reportData,
      submitDisabled: false,
      selectedManufacturer: null,
      manufacturers: [{ id: null, name: "Please select one" }]
    };
  },
  computed: {
    formAction() {
      return `/api/reports/${this.report.id}`;
    }
  },
  mounted() {
    if (this.report.report_date) {
      this.report.report_date = this.report.report_date.split(" ")[0];
    }

    this.getManufacturers().finally(() => {
      this.loading = false;
    });

    this.selectedManufacturer = this.report.manufacturer
      ? this.report.manufacturer.id
      : null;
  },
  methods: {
    getManufacturers() {
      return new Promise(resolve => {
        axios
          .get(`/api/clients/${this.report.template.client.id}/manufacturers`)
          .then(response => {
            this.manufacturers.push(...response.data.data);

            if (
              !this.manufacturers.find(
                m => m.id === this.report.manufacturer.id
              )
            ) {
              this.manufacturers.push(this.report.manufacturer);
            }
          })
          .finally(resolve);
      });
    },
    onSubmit(evt) {
      evt.preventDefault();

      this.submitDisabled = true;

      axios
        .put(this.formAction, {
          report_id: this.report.report_id,
          report_date: this.report.report_date,
          manufacturer_id: this.selectedManufacturer,
          comment: this.report.comment
        })
        .then(() => {
          this.submitDisabled = false;
          this.$bvModal.hide("modal-edit-form");
          this.$toasted.success("The information was successfully updated.", {
            duration: 3000
          });
        })
        .catch(error => {
          this.submitDisabled = false;
          this.$toasted.error("An error occurred while updating.", {
            duration: 3000
          });
        });
    }
  }
};
</script>
